import React from 'react'
import Button from './Button'

const ButtonAddCircle = (props) => {
  return (
    <Button
      icon="AddCircle"
      {...props}
    />
  )
}

export default ButtonAddCircle
